export default __webpack_public_path__ + "static/media/ml3.c74ac8c3.png";